import type React from 'react';

import { useSapCyclingProofExperiment } from '#src/app/pages/loginOrSignup/shared/hooks';
import { TrackExperimentExposure } from '#src/app/shared/components/tracking';

import { PromoPanel } from '../PromoPanel';
import { StepColumn } from '../StepColumn';

/**
 * The page content for a SAP visitor.
 *
 * Reaching this component already means the experiment is relevant, so exposure is recorded
 * unconditionally — both arms fire, and the hook no-ops on a fallback or a QA override. It mounts
 * once per page view (the page always starts on the email step), so exposure never re-fires on a
 * later step or a Back navigation.
 */
export const SapVisitorContent: React.FC<EmptyProps> = () => {
	const {
		data: { experiment, isTreatment },
	} = useSapCyclingProofExperiment();

	return (
		<>
			<TrackExperimentExposure experiment={experiment} />
			{isTreatment ? (
				// full-bleed: the grid replaces the page container so the promo panel reaches the viewport edge,
				// and carries the page min-height (see the layout's FIXME for the 101px) so the panel stretches to it
				<div data-testid="sap-two-column-grid" className="min-h-[calc(100vh-101px)] md:grid md:grid-cols-[1.05fr_1fr]">
					<PromoPanel />
					<div className="container">
						<div className="mx-auto w-full md:max-w-96">
							<StepColumn />
						</div>
					</div>
				</div>
			) : (
				// today's page wrapper, verbatim (see the layout's FIXME for the 101px)
				<div className="container min-h-[calc(100vh-101px)]">
					<div className="mx-auto md:w-96">
						<StepColumn />
					</div>
				</div>
			)}
		</>
	);
};
